<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
}
</script>

<style>
#app {
    font-size: 0;
    min-width: 1440px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue